import Orders from '../views/orders/list.vue'
export default [
  {
    path: '/orders',
    name: "orders",
    component: Orders
  }
]